import { apiClient } from "../api/apiClient";
import { assertSafePayload } from "../utils/inputValidation";

export const requestConsent = async (formData) => {
  try {
    assertSafePayload(formData, "consent request");
    const response = await apiClient.post("/v3/consent-int", formData);
    return response.data;
  } catch (error) {
    if (error.response?.data) {
      const errorData = error.response.data;
      let errorMessage = "Unknown error";

      // Handle nested error structure like {"error":{"error":{"code":"ABDM-1070","message":"Duplicate consent request"}}}
      if (
        errorData.error &&
        errorData.error.error &&
        errorData.error.error.message
      ) {
        errorMessage = errorData.error.error.message;
      } else if (errorData.error && typeof errorData.error === "string") {
        errorMessage = errorData.error;
      } else if (errorData.error && errorData.error.message) {
        errorMessage = errorData.error.message;
      } else if (errorData.message) {
        errorMessage = errorData.message;
      } else if (typeof errorData === "string") {
        errorMessage = errorData;
      } else {
        errorMessage = error.message || "Unknown error";
      }

      throw new Error(errorMessage);
    }
    throw error;
  }
};

